import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "skeleton" }
const _hoisted_2 = { class: "info" }

export function render(_ctx, _cache) {
  const _component_Skeleton = _resolveComponent("Skeleton")
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Skeleton, {
      class: "icon",
      width: "3.2rem",
      height: "4rem"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_skeleton, {
        class: "name",
        animated: ""
      }, {
        template: _withCtx(() => [
          _createVNode(_component_el_skeleton_item)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_el_skeleton, {
        animated: "",
        class: "size",
        style: {"width":"20%"}
      }, {
        template: _withCtx(() => [
          _createVNode(_component_el_skeleton_item)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}